import { AppState } from '../reducers/RootReducer';
import { createSelector } from 'reselect';

const getSignupCompleted = (state: AppState): boolean  => state.auth.signupCompleted;

export const getSignupCompletedSelector = createSelector(getSignupCompleted, (signupCompleted) => signupCompleted);

